import { useState } from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import UsageChart from "./usageChart";
const months = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];
export default function UsageCharts({ classes }) {
  const [selectedMonth, setSelectedMonth] = useState(dayjs().month() + 1);
  return (
    <div
      style={{
        flex: "1",
        height: "100%",

        padding: "24px",
      }}
    >
      <div
        style={{
          display: "flex",
          padding: "18px",
          width: "195px",
          height: "48px",
          border: "1px solid rgba(158, 158, 158, 1)",
          alignItems: "center",
          borderRadius: "12px",
        }}
      >
        <LeftOutlined
          style={{
            cursor: "pointer",
            color: selectedMonth === 1 ? "rgba(188, 188, 188, 1)" : "black",
          }}
          onClick={() =>
            selectedMonth !== 1 && setSelectedMonth(selectedMonth - 1)
          }
        />
        <span
          style={{
            fontSize: "20px",
            fontWeight: "600",
            marginLeft: "12px",
            width: "100px",
            textAlign: "center",
          }}
        >
          {months.find((item) => item.value === selectedMonth).label}
        </span>
        <RightOutlined
          style={{
            cursor: "pointer",
            color:
              selectedMonth === 12 || selectedMonth === dayjs().get("month") + 1
                ? "rgba(188, 188, 188, 1)"
                : "black",
            marginLeft: "12px",
          }}
          onClick={() =>
            selectedMonth !== dayjs().get("month") + 1 &&
            selectedMonth !== 12 &&
            setSelectedMonth(selectedMonth + 1)
          }
        />
      </div>

      {classes.map((item) => (
        <UsageChart curClass={item} month={selectedMonth} color={item.color} />
      ))}
    </div>
  );
}
